import React from "react";
import styled from "styled-components";

interface propsData {
  group: Group[];
  onClick(target: Group): void;
}

const GroupItemV2 = (props: propsData) => {
  return (
    <>
      <GroupTitle>그룹 채널</GroupTitle>
      <StyledGroup>
        {props.group &&
          props.group.map((value: Group, index: number) => {
            return (
              <StyledGroupItem key={index}>
                <div onClick={(e) => props.onClick(value)}>{value.group_name}</div>
              </StyledGroupItem>
            );
          })}
      </StyledGroup>
    </>
  );
};

const GroupTitle = styled.p`
  padding: 0 15px 15px;
  font-size: 16px;
  font-weight: 500;
`;

const StyledGroup = styled.ul`
  overflow: hidden;
  overflow-x: scroll;
  ${({ theme }) => theme.flexBox.flexMixin("row", "flex-start", "center")}
  padding: 0 15px 15px;
  border-bottom: 1px solid ${({ theme }) => theme.color.linePrimary};
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera*/
  }
  > li {
    margin-right: 10px;
    &:last-child {
      margin-right: 0;
    }
  }
`;
const StyledGroupItem = styled.li`
  flex-shrink: 0;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.color.main};
  ${({ theme }) => theme.flexBox.flexMixin("column", "center")}
  > a,
  > div {
    overflow: hidden;
    ${({ theme }) => theme.flexBox.flexMixin("row", "center", "center")}
    width: 60px;
    height: 60px;
    padding: 2px;
    text-align: center;
    color: #fff;
    font-size: 12px;
    line-height: 14px;
    word-break: break-all;
  }
`;

const PageMoveLink = styled.li`
  > a {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 60px;
    border: 1px solid ${({ theme }) => theme.color.lineSecondary};
    border-radius: 30px;
    &::before {
      position: absolute;
      top: 50%;
      left: 50%;
      content: "";
      display: block;
      width: 1px;
      height: 17px;
      margin-top: -8px;
      background-color: ${({ theme }) => theme.color.lineSecondary};
    }
    &::after {
      position: absolute;
      top: 50%;
      left: 50%;
      content: "";
      display: block;
      width: 17px;
      height: 1px;
      margin-left: -8px;
      background-color: ${({ theme }) => theme.color.lineSecondary};
    }
  }
`;

export default GroupItemV2;
